(ns dre.components.main-nav.views
  (:require
    [dre.app.router :refer [->route]]
    [dre.components.main-nav.db :as nav]
    [dre.utils.bem :as bem]))


(def component-name :main-nav)


(defn main-nav
  [page-id]
  [:ul
   {:class component-name}
   (for [{:keys [id related-ids label on-click]} nav/registry]
     ^{:key id}
     [:li
      {:class (bem/bem component-name :item (when (or (= page-id id) (contains? (set related-ids) page-id)) :active))}
      [:a {:on-click (or on-click (constantly nil))
           :href (->route id)}
       label]])])
